export default {
  higher: 'Valor mais alto',
  lower: 'Valor mais baixo ou zero',
  empty: 'Sem dados'
}
